












import Vue from 'vue';
import { mapActions } from 'vuex';
import HubIcon from './HubIcon.vue';

export default Vue.extend({
  name: 'HubToast' as string,
  components: {
    HubIcon,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timeout: null as NodeJS.Timeout | null,
    };
  },
  computed: {
    toastIcon() {
      if (this.notification.type === 'success') {
        return 'check';
      }
      if (this.notification.type === 'error') {
        return 'alert-circle-outline';
      }
      return null;
    },
  },
  mounted() {
    this.timeout = setTimeout(() => this.remove(this.notification), 3500);
  },
  methods: mapActions('notification', ['remove']),
});
